
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { default as SelectableMixin } from "./SelectableMixin.vue";

@Component({
})
export default class MultiSelectableMixin extends Mixins(SelectableMixin) {
  editingSource: any[];

  get selectedOptions(): any[] {
    return Enumerable.from(!this.editingSource ? [] : this.editingSource)
      .select(s => this.findOption(s, this.options))
      .where(o => !!o)
      .toArray();
  }

  set selectedOptions(options: any[]) {
    this.editingSource = options;
  }
}
